import React from 'react';
import FooterBlock from '../cms/blocks/types/FooterBlock';
import { useGlobals } from '../cms/useGlobals';

/**
 * Footer — thin wrapper around the CMS FooterBlock.
 *
 * TODO: move globals to backend `/api/website-cms/globals` once available.
 */
const Footer = () => {
  const globals = useGlobals();
  const data = globals?.footer?.data || globals?.footer;
  if (!data) return null;
  return <FooterBlock data={data} editing={false} />;
};

export default Footer;
